import React from "react";
import classes from "./Spinner.css";

const spin = () => <div className={classes.Loader}>Loading...</div>;
export default spin;



// WEBPACK FOOTER //
// ./src/components/UI/Spinner/Spinner.js